<template>
<div>
               <md-checkbox
                    :disabled="disabled"
                    class="md-primary moow-checkbox"
                    v-model="value"
                  >
                    {{title}}
                    <md-tooltip md-direction="bottom">{{tooltip}}</md-tooltip>
                  </md-checkbox>
    <!-- <input type="checkbox" :id="id" :name="name" :value="value" :disabled="disabled" class="moow-checkbox">
    <label :for="name">{{title}}</label> -->
</div>
</template>
<script>
export default {
  props: {
    tooltip: {
      type: String, 
      required: false
    },
    id: {
        type: String, 
        required: false
    },   
    name: {
      type: String, 
        required: false
    },
    title: String,
    value: String,
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  components: {},
  data() {
    return {};
  },
  filters: {},
  computed: {
   
  },
  mounted() {},
  created() {
  },
  methods: {
    
  }
};
</script>
<style scoped lang="scss">
@import "../../../assets/styles/variables.scss";

.moow-checkbox:checked:before{
background-color:green;
}

</style>



// WEBPACK FOOTER //
// src/components/interface/input/baseCheckbox.vue